export const Pulse = ({ color = 'bg-green-500' }) => (
  <span className="relative flex h-2 w-2">
    <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${color}`}></span>
    <span className={`relative inline-flex rounded-full h-2 w-2 ${color}`}></span>
  </span>
);